import { Component, OnDestroy, OnInit } from '@angular/core'
import { RouterLink } from '@angular/router'
import { NewsArticle } from '../news-article.model'
import { BaseArticleComponent } from 'src/app/shared/components/base-article-component/base-article-component'
import { PhoneFormatPipe } from '../../../shared/pipes/phone-format.pipe'
import { ListItemComponent } from '../../../shared/components/list-item/list-item.component'
import { MasterRouterLinkDirective } from '../../../../../projects/lib-master-detail/src/lib/directives/master-router-link.directive'
import { CourtDocumentsComponent } from '../../../shared/components/court-documents/court-documents'
import { NgxBootstrapIconsModule } from 'ngx-bootstrap-icons'
import { LinkedInComponent } from '../../../shared/components/linked-in/linked-in.component'
import { ContentViewer } from '../../../shared/components/content-viewer/content-viewer'
import { HeaderComponent } from '../../../shared/components/detail-header/detail-header.component'
import { AsyncPipe, DatePipe, KeyValuePipe, NgTemplateOutlet } from '@angular/common'
import { NgScrollbarModule } from 'ngx-scrollbar'
import { LoadingStatusComponent } from '../../../shared/components/loading-status/loading-status.component'
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap'
import { situationFollowOptions } from 'src/app/shared/follow-options'
import { FollowableLinkComponent } from 'src/app/shared/components/followable-link/followable-link.component'
import { SituationTimelineComponent } from 'src/app/shared/components/situation-timeline/situation-timeline.component'
import { SecDocumentsBlockComponent } from 'src/app/shared/components/sec-documents-block/sec-documents-block.component'

@Component({
    selector: 'app-news-article',
    templateUrl: './news-article.component.html',
    styleUrls: ['./news-article.component.scss'],
    imports: [
        LoadingStatusComponent,
        NgScrollbarModule,
        HeaderComponent,
        ContentViewer,
        RouterLink,
        LinkedInComponent,
        NgxBootstrapIconsModule,
        CourtDocumentsComponent,
        MasterRouterLinkDirective,
        ListItemComponent,
        AsyncPipe,
        DatePipe,
        KeyValuePipe,
        PhoneFormatPipe,
        NgbTooltipModule,
        NgTemplateOutlet,
        FollowableLinkComponent,
        SituationTimelineComponent,
        SecDocumentsBlockComponent
    ]
})
export class NewsArticleComponent extends BaseArticleComponent<NewsArticle> implements OnInit, OnDestroy {

  constructor() {
    let contentSet = 'news'
    if (window.location.pathname.includes('/newsletter/')) {
      contentSet = window.location.pathname.replace(/\/(.*)\/[0-9]+$/, '$1')
    }
    super()
    this.area = contentSet
  }

  getQueryParams(relatedNewsTypeDetails: any) {
    return {
      [relatedNewsTypeDetails.parameters]: relatedNewsTypeDetails.value + ':' + relatedNewsTypeDetails.name
    }
  }

  followThisSituation(event: Event, situation: any) {
    event.stopImmediatePropagation()
    this.savedSearchService.saveSearch({
      parameters: {
        area: 'situations',
        id: situation.situationname_cell?.situation_article_id ?? situation.situation_article_id,
        options: structuredClone(situationFollowOptions)
      },
      area: 'situations',
      type: 'follow',
      name: 'Follow: ' + (situation.case_name ?? situation.entity_name)
    })
  }

  unfollowThisArticle(event: Event, savedSearch: any) {
    event.stopImmediatePropagation()
    this.savedSearchService.deleteSearch(savedSearch)
  }


}